import { render } from "./jhi-sort-indicator.vue?vue&type=template&id=2a8bfca0&ts=true"
import script from "./jhi-sort-indicator.component.ts?vue&type=script&lang=ts&external"
export * from "./jhi-sort-indicator.component.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__